export function ReportsPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Reports</h1>
      <p className="text-gray-600">Reports coming soon...</p>
    </div>
  )
}
